<template>
  <div class="event-card-preview" v-if="item" :class="{'deleted': item.deleted}">
    <div class="inline-block">
      <!-- <span>
        <input
          id="willGoInputId"
          class="large-checkbox animated-checkbox"
          type="checkbox"
          v-model="item.iAmWillGo"
          :checked="true"
          :value="true"
          @click.prevent="willGoClick($event)"
          @input="iWillGoClick($event)"
        />
        <label for="willGoInputId">
          <span>ПОЙДУ</span>
          <span v-if="item.paid">
            <DollarCircleIcon class="header-icon mgl5" />
          </span>
        </label>
      </span> -->
      <label class="checkbox-container">
        <input
          id="willGoInputId"
          class="animated-checkbox"
          type="checkbox"
          :class="{ 'is-active': item.iAmWillGo }" 
          :checked="item.iAmWillGo"
          @click.prevent="willGoClick"
        />
        <span class="checkbox-label">
          <span>ПОЙДУ</span>
          <span v-if="item.paid">
            <DollarCircleIcon class="header-icon mgl5" />
          </span>
        </span>
      </label>
      <span class="geo-link"
        v-if="item.geoCoordinates && item.geoCoordinates.length > 2"
        @click="openMapModal(item.geoCoordinates)">
        <GeoMarkerIcon class="header-icon"/>
      </span>
    </div>
    <div>{{item.shortPlaceName}}</div>
    <div v-if="item.title && item.title.length > 1" class="news-source">«{{item.title}}»</div>
    <div class="tags link" v-if="item.tagsPlain && item.tagsPlain.length > 1"><sub>{{item.tagsPlain}}</sub></div>
    <div title="дата и время" class="item-state-description">
      <span class="rejected" v-if="item.isPast">&#x1F6C7;&nbsp;</span>
      <span v-if="item.isToday">сегодня</span>
      <span v-else-if="item.isTomorrow">завтра</span>
      <span v-else>{{item.dateTimeUtc | formatDateTimeOffset}}</span>
      <span v-if="item.timeStart && item.timeStart.length"> в {{item.timeStart | shortTime}}</span>
    </div>
    <div class="going-users-container" v-if="item.goingUsersCount" @click="showGoingUsers">
      <circle-counter v-if="item.goingUsersCount>99" value="99+" :size="30" />
      <circle-counter v-else :value="item.goingUsersCount" :size="30" />
      <span class="going-users-avatars" v-if="item.goingUsers && item.goingUsers.length">
        <span class="going-user-avatar" v-for="(user, index) in item.goingUsers.slice(0, 7)" :key="index">
          <avatar-circle :username="user.shortUserName" :readonly="true" :src="$host.host + user.avatarUrl" :size="30" />
        </span>
      </span>
    </div>
    <!-- Оборачиваем модалку во Vue Transition -->
    <transition
      name="slide-up"
      @after-enter="onAfterEnter"
      @before-leave="onBeforeLeave"
    >
      <!-- Модальное окно -->
      <div v-if="isModalOpen" class="modal-backdrop" @click.self="closeModal">
        <div
          class="modal-content"
          :class="{ 'modal-animating': !isSwiping }"
          :style="isReady ? { transform: `translateY(${translateY}px)` } : null"
        >
          <div
            class="modal-header-container"
            @touchstart="onTouchStart"
            @touchmove="onTouchMove"
            @touchend="onTouchEnd"
            @touchcancel="onTouchEnd" 
          >
            <div class="handle-bar"></div>
            <div class="modal-header">
              <span class="modal-header-title">Местоположение</span>
              <button title="закрыть" aria-label="закрыть окно местоположения" class="close-btn" @click="closeModal">&times;</button>
            </div>
          </div>
          
          <!-- Используем iframe для отображения карты -->
          <iframe 
            :src="iframeUrl"
            :class="{ 'dark-map': false }"
            class="backdrop-iframe-style"
            width="100%" 
            height="400" 
            frameborder="0" 
            allowfullscreen="true"
            tyle="position: relative; border: none; border-radius: 4px; display: block;"
          ></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AvatarCircle from './AvatarCircle.vue';
export default {
  components: { AvatarCircle },
  name: 'CalendarEventCardPreview',
  props: {
    item: {},
  },
  data() {
    return {
      isUpdateGoingUsers: false,
      isModalOpen: false,
      iframeUrl: '',

      // Логика свайпа
      startY: 0,       // Начальная точка касания Y
      currentY: 0,     // Текущая точка касания Y
      translateY: 0,   // На сколько пикселей сдвинута модалка вниз
      isSwiping: false, // Флаг, что идет процесс свайпа,
      isReady: false    // Новый флаг: разрешает свайпы только ПОСЛЕ полной загрузки анимации
    };
  },
  watch: {
    // Наблюдаем за открытием и закрытием модалки
    isModalOpen(isOpen) {
      if (isOpen) {
        // Полный сброс всех координат при повторном открытии
        this.startY = 0;
        this.currentY = 0;
        this.translateY = 0;
        this.isSwiping = false;
        // Принудительно держим false, пока Vue строит анимацию
        this.isReady = false; 
      }/* else {
        // На всякий случай очищаем и при закрытии
        this.translateY = 0;
      }*/
    }
  },
  methods: {
    showGoingUsers() {
      if (!this.$store.getters.isAuthenticated) {
        this.$emit('auth-required', 'Участники мероприятия');
        return;
      }
    },
    willGoClick() {
      if (this.loader || this.isUpdateGoingUsers) return;
      if (!this.$store.getters.isAuthenticated) {
        this.$emit('auth-required');
        return;
      }
      this.item.iAmWillGo = !this.item.iAmWillGo;
      this.iWillGoClick();
    },
    iWillGoClick() {
      const payload = {
        calendarEventId: this.item.id,
        isConfirmed: this.item.iAmWillGo
      };
      this.loader = true;
      this.$http.post(`${this.$host.CalendarServiceApi}/ConfirmEvent`, payload)
      .then(() => {
        this.loader = false;
        this.updateGoingUsers();
      })
      .catch(() => {
        this.loader = false;
      })
    },
    updateGoingUsers() {
      this.isUpdateGoingUsers = true;
      const query = {
        calendarEventId: this.item.id
      };
      this.$http.get(`${this.$host.CalendarServiceApi}/GetGoingUsersByCalendarEventId`, { params: query })
      .then((response) => {
        const data = response.body;
        if (data) {
          this.item.iAmWillGo = data.iAmWillGo;
          this.item.goingUsers = data.goingUsers;
          this.item.goingUsersCount = data.goingUsersCount;
        }
        this.isUpdateGoingUsers = false;
      })
      .catch((e) => {
        if (e && e.status === 404) {
          this.item.deleted = true;
        }
        this.isUpdateGoingUsers = false;
      })
    },
    openMapModal(coords) {
      const ab = coords.split(',');
      this.iframeUrl = `https://yandex.ru/map-widget/v1/?whatshere[point]=${ab[1]}%2c${ab[0]}&z=15`;

      // const url = `https://yandex.ru:443/maps/?whatshere[point]=${ab[1]}%2c${ab[0]}&whatshere[zoom]=15`;
      // const url = `https://yandex.ru/maps/?whatshere[point]=${ab[1]}%2c${ab[0]}&z=15`;

      // // Превращаем обычную ссылку в ссылку для виджета (заменяем /maps/ на /map-widget/v1/)
      // // Это позволит обойти блокировку X-Frame-Options в iframe
      // if (url.includes('/maps/?')) {
      //   this.iframeUrl = url.replace('/maps/?', '/map-widget/v1/?');
      // } else if (url.includes('/maps/')) {
      //   this.iframeUrl = url.replace('/maps/', '/map-widget/v1/');
      // } else {
      //   this.iframeUrl = url;
      // }
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.iframeUrl = ''; // Очищаем ссылку при закрытии, чтобы iframe сбрасывался
    },
    handleKeyDown(event) {
      if (this.isModalOpen && event.key === 'Escape') {
        this.closeModal();
      }
    },
    // Вызывается автоматически, когда модалка ПОЛНОСТЬЮ выехала на экран
    onAfterEnter() {
      this.isReady = true;
    },

    // Вызывается автоматически в момент, когда модалка НАЧИНАЕТ закрываться
    onBeforeLeave() {
      this.isReady = false;
    },
    // Тач-события разрешаем обрабатывать только если шторка уже раскрыта (isReady === true)
    onTouchStart(event) {
      if (!this.isReady) return;
      this.startY = event.touches[0].clientY;
      this.isSwiping = true;
    },
    onTouchMove(event) {
      if (!this.isSwiping) return;
      this.currentY = event.touches[0].clientY;
      const diffY = this.currentY - this.startY;
      if (diffY > 0) {
        this.translateY = diffY;
      }
    },
    onTouchEnd() {
      if (!this.isSwiping) return;
      this.isSwiping = false;
      if (this.translateY > 150) {
        this.closeModal();
      } else {
        this.translateY = 0;
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
}
</script>

<style scoped>
.event-card-preview {
  background-color: var(--option-group-background-color);
  margin-bottom: 1em;
  border-radius: 10px;
  width: calc(100% - 1rem);
  padding: 0.5rem;
}
.event-card-preview.disabled {
  background-color: var(--option-group-background-color_disabled);
}
.event-card-preview.deleted {
  background-color: var(--option-group-background-color_deleted);
}
.inline-block {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.geo-link {
  float: inline-end;
  display: inline-flex;
  /* font-size: 1.25rem; */
  align-self: flex-start;
  cursor: pointer;
}
.mgl5 {
  margin-left: 0.5rem;
}
.tags {
  margin-bottom: 0.1rem;
}


.going-users-container {
  margin-top: 0.375rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.going-users-avatars {
  margin-left: 0.5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  max-width: calc(100% - 0.5rem);
}

.going-user-avatar {
  margin-left: -8px;
  border-radius: 50%;
}

.going-user-avatar:first-of-type {
  margin: 0
}

</style>

<style scoped src='../assets/css/animated-checkbox.css'>
</style>

<style scoped src='../assets/css/map-modal.css'>
</style>